<template>
  <div class="smartpark-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入名称查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
          <FormItem>
            <Button @click="showModel()" type="success" class="f-r">添加</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer
      :title="title"
      v-model="showModalStatus"
      width="800"
      :mask-closable="false"
      :styles="styles"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        label-position="top"
        action="javascript:void(0)"
      >
        <FormItem label="选择园区">
          <Select v-model="dataInfo.park_uuid" filterable clearable>
            <Option
              v-for="item in parkList"
              :value="item.park_uuid"
              :key="item.park_uuid"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="名称">
          <Input v-model="dataInfo.title" placeholder="请输入标题" />
        </FormItem>-->
        <FormItem label="领导电话">
          <Input v-model="dataInfo.lead_phone" placeholder="请输入领导电话" />
        </FormItem>
        <FormItem label="内容">
          <!--          <editor-bar v-model="dataInfo.content" :isClear="isClear" ref="editContent"></editor-bar>-->
          <UEditor v-model="dataInfo.content" ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="通票购票须知">
          <!--          <editor-bar v-model="dataInfo.notice_throughticket" :isClear="isClear" ref=""></editor-bar>-->
          <UEditor v-model="dataInfo.notice_throughticket" ref></UEditor>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus = false">取消</Button>
        <Button type="primary" @click="createpushtype('dataInfoValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UEditor from "../common/ueditor";

export default {
  name: "smartpark-list",
  data() {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      title: "",
      isClear: false,
      loading: true,
      dataloading: true,
      formItem: {},
      thumblist: [],
      parkList: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns: [
        {
          title: "Id",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "title",
          fixed: "left"
        },
        {
          title: "领导电话",
          key: "lead_phone",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      dataInfo: {
        title: "",
        content: ""
      },
      showModalStatus: false,
      editor: {},
      dataInfoValidate: {}
    };
  },
  // 计算
  computed: {},
  components: {
    UEditor
  },
  // 监听
  watch: {},
  created: function() {
    this.$api.park.list({ page: 1, size: 9999 }).then(res => {
      if (res.code == 200) {
        this.parkList = res.result.list;
      }
    });
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.smartpark
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 展开添加
    showModel() {
      this.dataInfoid = 0;
      this.dataInfo = {
        title: "",
        content: ""
      };
      // this.$refs["editContent"].editor.txt.html("");
      // this.$refs["editContent1"].editor.txt.html("");
      this.$refs["editContent"].message = "";
      this.$refs[""].message = "";
      this.$refs["dataInfoValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    detail: function(index) {
      this.dataInfoid = index;
      this.showModalStatus = !this.showModalStatus;
      this.$api.smartpark.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.dataInfo = res.result;
          // this.$refs["editContent"].editor.txt.html(this.dataInfo.content);
          // this.$refs[""].editor.txt.html(
          //   this.dataInfo.notice_throughticket
          // );
          this.$refs["editContent"].message = this.dataInfo.content;
          this.$refs[""].message = this.dataInfo.notice_throughticket;
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加/修改
    createpushtype(name) {
      this.dataInfo.content = this.$refs["editContent"].message;
      this.dataInfo.notice_throughticket = this.$refs[""].message;
      if (
        this.dataInfoid == null ||
        this.dataInfoid == 0 ||
        this.dataInfoid == undefined
      ) {
        this.$api.smartpark.create(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.showModalStatus = !this.showModalStatus;
            this.getTableList();
          }
        });
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      } else {
        //编辑商品
        this.dataInfo.id = this.dataInfoid;
        this.$api.smartpark.edit(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = false;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
      }
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      // console.log(ps);
      this.$api.smartpark.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.smartpark.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>
